module.exports = __webpack_public_path__ + "img/intro/image@2x.jpg";